module.exports = __webpack_public_path__ + "static/media/birthdaycake.a1919665.svg";